var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as main from "../export";
import { DeviceConnectivity } from "../shared/types/types";
import { Device, NewDevice, DevicePatch, AdditionalParams, } from "./DeviceManager";
import axios from "axios";
import { generateStervalHarvestParams } from "./utils";
export class ATRDevice extends Device {
    constructor(id, label, owner, notOwned, connectivity, attributes, lastActivity, provisioningInProcess, deviceProfileId, dataConverterId, rawLastTelemetry, rawLastEvents, rawLastGeolocation) {
        super(id, label, owner, notOwned, connectivity, attributes, lastActivity, provisioningInProcess, deviceProfileId);
        this.dataConverterId = dataConverterId;
        this.rawLastTelemetry = rawLastTelemetry;
        this.rawLastEvents = rawLastEvents;
        this.rawLastGeolocation = rawLastGeolocation;
    }
    static deserialize(rawDevice) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const id = rawDevice.id;
        const label = (_a = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) === null || _a === void 0 ? void 0 : _a.label;
        const owner = (_b = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) === null || _b === void 0 ? void 0 : _b.owner;
        const notOwned = (_c = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) === null || _c === void 0 ? void 0 : _c.notOwned;
        const deviceProfile = ((_d = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) === null || _d === void 0 ? void 0 : _d.device_profile) || null;
        const dataConverter = ((_e = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) === null || _e === void 0 ? void 0 : _e.converter) || null;
        const attributes = {};
        const lastActivity = ((_f = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.configuration_signaled) === null || _f === void 0 ? void 0 : _f.timestamp) || null;
        const provisioningInProcess = false;
        const rawLastTelemetry = ((_h = (_g = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.configuration_signaled) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.telemetry) || [];
        const rawLastGeolocation = ((_k = (_j = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.configuration_signaled) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.geolocation) || [];
        const rawLastEvents = ((_m = (_l = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.configuration_signaled) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.events) || [];
        let connectivity = main.shared.types.deserializeDeviceConnectivity((_o = rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) === null || _o === void 0 ? void 0 : _o.technology);
        for (let ai of Object.keys((rawDevice === null || rawDevice === void 0 ? void 0 : rawDevice.attributes) || {})) {
            if (ai !== "device_profile" &&
                ai !== "owner" &&
                ai !== "label" &&
                ai !== "converter" &&
                ai !== "technology" &&
                ai !== "notOwned") {
                attributes[ai] = rawDevice.attributes[ai];
            }
        }
        return new ATRDevice(id, label, owner, notOwned, connectivity, attributes, lastActivity, provisioningInProcess, deviceProfile, dataConverter, rawLastTelemetry, rawLastEvents, rawLastGeolocation);
    }
}
export class ATRDevicePatch extends DevicePatch {
    constructor(id, label = null, deviceProfileId = null, dataConverterId = null, attributes = null) {
        super(id, label, deviceProfileId, attributes);
        this.dataConverterId = dataConverterId;
    }
}
export class ATRNewDevice extends NewDevice {
    constructor(id, label, connectivity, deviceProfileId = null, certificate = null, algorithm = "RSA_2048", apikey = null, manual_provisioning = null, additionalParams = null) {
        super(id, label, connectivity, deviceProfileId, certificate, algorithm);
        this.apikey = apikey;
        this.manual_provisioning = manual_provisioning;
        this.additionalParams = additionalParams;
    }
}
export class LoRaTTNAdditionalParams extends AdditionalParams {
    constructor(deviceEUI, loraWANVersion, loraWANPHYVersion, frequencyPlanId) {
        super();
        this.deviceEUI = deviceEUI;
        this.loraWANVersion = loraWANVersion;
        this.loraWANPHYVersion = loraWANPHYVersion;
        this.frequencyPlanId = frequencyPlanId;
    }
    toJson() {
        return {
            device_eui: this.deviceEUI,
            lora_wan_version: this.loraWANVersion,
            lora_wan_phy_version: this.loraWANPHYVersion,
            frequency_plan_id: this.frequencyPlanId,
        };
    }
}
export class PolarisAdditionalParams extends LoRaTTNAdditionalParams {
    constructor(deviceMac, deviceEUI, loraWANVersion, loraWANPHYVersion, frequencyPlanId) {
        super(deviceEUI, loraWANVersion, loraWANPHYVersion, frequencyPlanId);
        this.deviceMac = deviceMac;
        this.deviceEUI = deviceEUI;
        this.loraWANVersion = loraWANVersion;
        this.loraWANPHYVersion = loraWANPHYVersion;
        this.frequencyPlanId = frequencyPlanId;
    }
    toJson() {
        return {
            device_mac: this.deviceMac,
            device_eui: this.deviceEUI,
            lora_wan_version: this.loraWANVersion,
            lora_wan_phy_version: this.loraWANPHYVersion,
            frequency_plan_id: this.frequencyPlanId,
        };
    }
}
/**
 * @interface
 *
 * @name ATRDeviceManager
 * @description Interface exposed by device manager Asset-Tracking microservice
 * @author STMicroelectronics, Davide Sergi
 */
export class ATRDeviceManager {
    constructor(baseUrl, authorizer, region) {
        this.baseUrl = baseUrl;
        this.authorizer = authorizer;
        this.region = region;
    }
    getDevices(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/devices`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders,
            };
            const response = yield axios.get(url.href, opt);
            const rawDevices = response.data;
            return rawDevices.map((rd) => ATRDevice.deserialize(rd));
        });
    }
    getDevice(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/devices/${id}`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "GET", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders,
            };
            const response = yield axios.get(url.href, opt);
            const rawDevice = response.data;
            return ATRDevice.deserialize(rawDevice);
        });
    }
    createDevice(device, credentials) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/devices`, this.baseUrl.href);
            let rawDevice = {
                device_id: device.id,
                label: device.label,
                device_profile: device.deviceProfileId || undefined,
                device_type: device.connectivity.toString(),
            };
            rawDevice[device.connectivity.toString()] = {
                technology: device.connectivity.toString(),
                api_key: device.apikey || undefined,
                certificate: device.certificate || undefined,
                manual_provisioning: device.manual_provisioning || undefined,
                algorithm: device.algorithm || undefined,
            };
            Object.assign(rawDevice[device.connectivity.toString()], ((_a = device.additionalParams) === null || _a === void 0 ? void 0 : _a.toJson()) || {});
            if (device.connectivity === DeviceConnectivity.STEVALHARVEST1) {
                const params = generateStervalHarvestParams(device);
                rawDevice[device.connectivity.toString()].params = params;
            }
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "POST", url.hostname, url.pathname, url.search, JSON.stringify(rawDevice), "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders,
            };
            try {
                const res = yield axios.post(url.href, rawDevice, opt);
                return res.data;
            }
            catch (err) {
                console.log(JSON.stringify(err));
                if (err.response) {
                    console.error("Error status:", err.response.status);
                    console.error("Server message:", err.response.data);
                    throw err.response;
                }
                else if (err.request) {
                    console.error("No response received:", err.request);
                }
                else {
                    console.error("Unexpected error:", err.message);
                }
                throw err;
            }
        });
    }
    updateDevice(device, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/devices/${device.id}`, this.baseUrl.href);
            let attributesPatch = {};
            let patch = {};
            Object.assign(device.attributes, attributesPatch);
            attributesPatch["label"] = device.label;
            attributesPatch["device_profile"] = device.deviceProfileId;
            attributesPatch["converter"] = device.dataConverterId;
            patch.device_id = device.id;
            patch.configuration = device.configuration || undefined;
            patch.attributes = attributesPatch;
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "PUT", url.hostname, url.pathname, url.search, JSON.stringify(patch), "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders,
            };
            yield axios.put(url.href, patch, opt);
        });
    }
    deleteDevice(id, credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = new URL(`/v1/devices/${id}`, this.baseUrl.href);
            const sigv4Descriptor = new main.shared.auth.sigv4.SigV4RequestDescriptor(credentials, "DELETE", url.hostname, url.pathname, url.search, "", "execute-api", this.region);
            const authHeaders = this.authorizer.authorize(sigv4Descriptor);
            let opt = {
                headers: authHeaders,
            };
            yield axios.delete(url.href, opt);
        });
    }
}
//# sourceMappingURL=ATRDeviceManager.js.map